<template>
  <div id="Maingallery">
    <Gallery/>
  </div>
</template>

<script>
import Gallery from '../components/Gallery.vue'

export default {
  name: 'MainGallery',
  components: {
    Gallery
  }
}
</script>

<style>
 
</style>